<template>
    <on-click-outside :do="reset">
        <div class="search" :class="{ 'in-hero': inHero }">
            <div class="flex items-center text-xs relative h-4xl">
                <input
                    ref="input"
                    v-model="query"
                    type="text"
                    placeholder="Sök produkter…"
                    class="w-full px-2xl text-placeholder focus:outline-none"
                    aria-label="Sök produkter"
                    :autofocus="! inHero"
                    maxlength="40"
                    @keydown.down="down"
                    @keydown.up="up"
                    @keydown.enter="handleEnter"
                    @keydown.esc="reset"
                    @input="update"
                    @paste="update"
                >

                <span v-if="iconBg" class="icon-with-background absolute left-0">
                    <font-awesome-icon :icon="icon" />
                </span>
                <font-awesome-icon
                    v-else
                    :icon="icon"
                    class="absolute left-0"
                />

                <button
                    v-if="query"
                    type="button"
                    class="absolute right-0 hover:text-pink-500"
                    :class="{ 'mr-2xl': inHero }"
                    @click="reset"
                >
                    <font-awesome-icon icon="times-circle" />
                </button>
            </div>

            <div
                v-if="hasItems || hasSearched"
                class="search-results"
                :class="{ 'lg:mt-2xl': ! inHero, 'mt-md': inHero }"
            >
                <div v-if="hasItems">
                    <div class="label mb-sm">Produkter</div>
                    <ul class="mb-0">
                        <li
                            v-for="(item, index) in items"
                            :key="index"
                            class="p-lg flex items-center"
                            :class="activeClass(index)"
                            @mousemove="setActive(index)"
                            @mousedown="hit"
                        >
                            <div class="h-4xl w-4xl flex-center mr-sm">
                                <img
                                    :src="item.thumbnail_image_url"
                                    :alt="item.name"
                                    class="max-h-full max-w-full w-auto"
                                >
                            </div>
                            <div>
                                <div class="text-xxs mb-xs">{{ item.brand.name }}</div>
                                <div class="h4 mb-0">{{ item.name }}</div>
                            </div>
                        </li>
                    </ul>
                    <div>
                        <a :href="searchResultsIndexUrl" class="block mt-lg p-lg text-center text-xs font-semibold rounded-lg hover:text-green-500 hover:bg-gray-100">Alla resultat</a>
                    </div>
                </div>
                <div v-else class="mb-lg">
                    <span class="text-xs text-gray-700 italic">Sökningen gav inget resultat…</span>
                </div>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
    import VueTypeahead from '@/Atlantis/Frame/GeneralBar/SuperSearcher/VueTypeahead';

    export default {
        extends: VueTypeahead,

        props: {
            inHero: {
                type: Boolean,
                default: false,
            },
            iconBg: {
                type: Boolean,
                default: false,
            },
            initialQuery: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                src: route('front.api.product-search-results'),
                minChars: 2,
                query: this.initialQuery,
            };
        },
        computed: {
            icon() {
                if (this.loading) {
                    return 'spinner';
                }

                return 'search';
            },
            hasSearched() {
                return this.query && this.query.length >= this.minChars
                    && ! this.loading && ! this.hasItems && this.items !== null;
            },
            searchResultsIndexUrl() {
                return route('front.product-search-results.index', {
                    [encodeURI('filter[query]')]: this.query,
                });
            },
        },
        created() {
            EventBus.$on('header-search-opened', () => {
                if (this.inHero) {
                    return;
                }

                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            });
        },
        methods: {
            onHit(item) {
                window.location.href = item.url;
            },
            handleEnter() {
                if (this.current === -1) {
                    window.location = this.searchResultsIndexUrl;
                } else {
                    this.hit();
                }
            },

        },
    };
</script>
